import React from "react";
import {
  Flex,
  Text,
  Modal,
  Button,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ListItem,
  List,
} from "@chakra-ui/react";

const PreferItemNoteModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={"750px"}
        borderRadius={"16px"}
        p={6}
        alignSelf={"center"}
      >
        <ModalBody
          gap={4}
          display={"flex"}
          //   alignItems={"center"}
          flexDirection={"column"}
        >
          <Text
            fontSize={"24px"}
            fontFamily={"PlusJakartaSansSemiBold"}
            color={"#000000"}
            textAlign={"center"}
          >
            Note
          </Text>
          <List spacing={2} styleType="disc" pl={2}>
            <ListItem
              fontSize={"16px"}
              fontFamily={"PlusJakartaSansRegular"}
              color={"#000000"}
              textTransform={"lowercase"}
            >
              Please check for any stains, tears, pulls
            </ListItem>
            <ListItem
              fontSize={"16px"}
              fontFamily={"PlusJakartaSansRegular"}
              color={"#000000"}
              textTransform={"lowercase"}
            >
              Rejected items incur a return charge of{" "}
              <Text as="span" fontFamily={"PlusJakartaSansBold"}>
                £2.95
              </Text>{" "}
              per item
            </ListItem>
          </List>
          <Flex justifyContent={"center"} gap={3} pt={6}>
            <Button
              onClick={onClose}
              width={"174px"}
              height={"40px"}
              borderRadius={"12px"}
              bg={"none"}
              border={"1px solid #000000"}
              color={"#000000"}
              fontSize={"12px"}
              fontWeight={"500"}
              fontFamily={"PlusJakartaSansMedium"}
              letterSpacing={0.2}
            >
              OK
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PreferItemNoteModal;
